import React from 'react';
import ContactLink from '../header/ContactLink';
import Button from '../Button';
import styles from './help-cta.module.scss';

const HelpCta = () => (
  <div className={styles.HelpCta}>
    <div>
      <p className={styles.HelpCta__eyebrow}>Still need help?</p>
      <h2 className={styles.HelpCta__heading}>
        We’re real people who are always happy to help.
      </h2>
    </div>
    <div className={styles.HelpCta__actions}>
      <ContactLink size="medium" variant="inverse" />
      <Button
        href="https://app.teamgantt.com/book-a-demo?ref=helpdocs"
        variant="inverseOutline"
      >
        Schedule live help
      </Button>
    </div>
  </div>
);

export default HelpCta;



// WEBPACK FOOTER //
// ./src/components/help-cta/index.js